import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const selectAccountOverviewSlice = createStatePropertySelector(selectSalesIntelligenceState("accountOverview"));
export const selectCompanySlice = selectAccountOverviewSlice("company");
export const selectSharedSlice = selectAccountOverviewSlice("shared");
export const selectCompetitiveLandscapeSlice = selectAccountOverviewSlice("competitiveLandscape");
